import { Divider, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, selectAuthUser } from "../../store/slices/authSlice";

const ShineButton = styled("button")(() => ({
  position: "relative",
  width: "100%",
  padding: "12px 18px",
  borderRadius: 999,
  border: "1px solid rgba(17, 24, 39, 0.18)",
  backgroundColor: "#0f172a",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: 14,
  letterSpacing: "0.02em",
  cursor: "pointer",
  overflow: "hidden",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "-75%",
    width: "50%",
    height: "220%",
    background:
      "linear-gradient(135deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 45%, rgba(255,255,255,0) 75%)",
    transform: "translateY(-50%) rotate(25deg)",
    transition: "left 0.6s ease",
    pointerEvents: "none",
  },
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0px 10px 24px rgba(15, 23, 42, 0.25)",
  },
  "&:hover::before": {
    left: "130%",
  },
  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0px 6px 16px rgba(15, 23, 42, 0.18)",
  },
}));

const UserMenu = ({ anchorEl, onClose }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const open = Boolean(anchorEl);

  const handleLogout = () => {
    dispatch(logoutUser());
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            minWidth: 240,
            p: 2,
            boxShadow: "0px 22px 45px rgba(15, 23, 42, 0.18)",
            border: "1px solid rgba(148, 163, 184, 0.16)",
            background:
              "radial-gradient(circle at top right, rgba(14, 165, 233, 0.24), transparent 55%), #ffffff",
          },
        },
      }}
    >
      <Stack spacing={0.5} sx={{ pb: 1 }}>
        <Typography variant="subtitle1">{user?.name || "System Admin"}</Typography>
        <Typography variant="body2" color="text.secondary">
          {user?.role || "Administrator"}
        </Typography>
      </Stack>
      <Divider sx={{ my: 1 }} />
      <MenuItem
        disableRipple
        sx={{
          p: 0,
          bgcolor: "transparent",
          "&:hover": { bgcolor: "transparent" },
        }}
      >
        <ShineButton type="button" onClick={handleLogout}>
          Logout
        </ShineButton>
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;
